import { useEffect } from 'react';
import { shell, IPCRendererCallback } from '@frontend/shell-utils';
import { useTopBarShallowStore } from '../store/use-top-bar-store';

export const useVersionUpdates = () => {
  const { setNextVersion } = useTopBarShallowStore('setNextVersion');

  useEffect(() => {
    if (!shell?.isShell) return;
    const id = 'update:new-version-available' + Math.random();
    const cb: IPCRendererCallback<'update:new-version-available'> = (_e, payload) => {
      const version = payload?.version;
      setNextVersion(version);
    };
    shell.on?.('update:new-version-available', cb, id);
    return () => {
      shell.off?.('update:new-version-available', cb, id);
    };
  }, [setNextVersion]);

  useEffect(() => {
    if (!shell.isShell) return;
    const cb: IPCRendererCallback<'info:update-available'> = (_e, payload) => {
      const version = payload?.version;
      if (version) setNextVersion(version);
    };
    const id = 'info:update-available' + Math.random();
    shell.emit?.('info:update-available', undefined);
    shell.on?.('info:update-available', cb, id);
    return () => {
      shell.off?.('info:update-available', cb, id);
    };
  }, [setNextVersion]);
};
